import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";
import appdownloadicon from "../assets/images/header-appdownload-icon.svg"
import headerserviceicon from "../assets/images/header-service-icon.svg"
import { isEmpty } from "lodash";
import AuthContext from "../context/AuthContext";
import apiPath from "../Utils/apiPath";
import {
  MdArrowBackIosNew,
  MdKeyboardArrowLeft,
  MdOutlineRefresh,
  MdOutlineSubject,
} from "react-icons/md";
import { FaCaretDown, FaSearchPlus, FaSignInAlt, FaSignOutAlt, FaUndo, FaUser } from "react-icons/fa";
import MenuSidebar from "./MenuSidebar";
import MenuSidebarNew from "./MenuSidebarNew";
import { HiOutlineRefresh } from "react-icons/hi";
import { useTranslation } from "react-i18next";
// import bajiApk from "/baji247.apk";
import crose from "../assets/images/cross-black.svg";
//  import downloadapp from "../assets/images/favicon.ico";
import logoutImg from "../assets/images/logout.svg";
import bournemouth from "../assets/images/bournemouth.png";
import bologna from "../assets/images/bologna.png";
import { IoMdSettings } from "react-icons/io";
import MessageBox from "./MessageBox";
import AgeConfirmationModal from "./AgeConfirmationModal";
import { apiGet } from "../Utils/apiFetch";

const HeaderNew = ({ desktopHome = false }) => {
  const [showAgeModal, setShowAgeModal] = useState(false);
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia("(min-width: 1024px)").matches);
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [accountOpen, setAccountOpen] = useState(false);
  const accountRef = useRef(null);
  const accountButtonRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    setAccountOpen(false);
  }, [pathname, isDesktop, desktopHome]);

  useEffect(() => {
    if (!accountOpen) return;
    const closeOutside = event => {
      if (!accountRef.current?.contains(event.target)) setAccountOpen(false);
    };
    const closeOnEscape = event => {
      if (event.key === "Escape") {
        setAccountOpen(false);
        accountButtonRef.current?.focus();
      }
    };
    document.addEventListener("pointerdown", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [accountOpen]);

  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const update = () => setIsDesktop(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);
  const {
    user,
    user_coins,
    setUserCoins,
    handleShowSidebar,
    showSidebar,
    amounutRefresh,
    refreshAmountLoader,
    userCoins,
    loginUser,
    setShowDownloadBar,
    downloadBar,
    logoutUser,
    setOpenBetsToogle,
    setSettingToogle,
    settingToogle,
    searchToogle,
    setSearchToogle
  } = useContext(AuthContext);
  const navigate = useNavigate()
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState(false);
  const [amount, setAmount] = useState(0);
  const [showMultiWallet, setShowMultiWallet] = useState(false); // State to control wallet visibility

  const getCoins = async () => {
    if (isEmpty(user)) return;

    setRefresh(true);

    try {
      const { status, data } = await apiGet(apiPath.refreshAmount);

      if (status === 200 && data?.success) {
        const { exposure, totalCoins } = data.results || {};
        setAmount(totalCoins);
        // Prevent unnecessary re-render
        setUserCoins((prev) =>
          prev?.exposure === exposure && prev?.totalCoins === totalCoins
            ? prev
            : { exposure, totalCoins }
        );
      }
    } catch (error) {
      console.log("getCoins error:", error);
    } finally {
      setRefresh(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      getCoins();
    }
  }, [user]);

  const SIX_SECOND_MS = 6000;

  useEffect(() => {
    if (!isEmpty(user)) {
      const interval = setInterval(() => {
        getCoins();
      }, SIX_SECOND_MS);

      return () => clearInterval(interval);
    }
  }, [user]);

  // Toggle function for multi wallet
  const toggleMultiWallet = () => {
    setShowMultiWallet(!showMultiWallet);
  };

  // Function to close multi wallet when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const multiWalletDiv = document.getElementById('multiWalletDiv');
      const multiWalletButton = document.getElementById('multiWallet');
      
      if (showMultiWallet && multiWalletDiv && !multiWalletDiv.contains(event.target) && !multiWalletButton.contains(event.target)) {
        setShowMultiWallet(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMultiWallet]);

  const submitDesktopLogin = async () => {
    setShowAgeModal(false);
    setSubmitting(true);
    setLoginError("");
    try {
      await loginUser({ ...credentials, uniqueId: Math.random() * 10000 });
    } catch (error) {
      setLoginError("Unable to log in. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* {
      downloadBar && 
      <div class="download-bar">
        <img width="15" height="15" src={crose} alt="download" class="mr-2 crose-icon" onClick={() => setShowDownloadBar(false)}/>
          <img width="32" height="32" src={downloadapp} alt="download" class="mr-2 c-radis" />
            <div class="mr-1 col">
              <b>{t("DOWNLOAD_APP")}</b>
            </div>
            <button data-v-3b7d3367="" type="button" class="pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default download-bar-button subtitle-1">
              <a class="v-btn__content" href={"#"} download="Melbet" target='_blank'>DOWNLOAD</a>
              </button>
    </div>
    } */}
      {desktopHome && isDesktop ? (
        <div className="desktop-home-header">
          <Link to="/" className="desktop-home-logo" aria-label="Home"><img src={logo} alt="King" /></Link>
          <div className="desktop-header-actions">
            <div id="desktop-header-search" className={`desktop-header-search-slot${searchToogle ? " is-open" : ""}`} />
            <button
              id="desktop-search-toggle"
              type="button"
              className="desktop-search-button"
              aria-label={searchToogle ? "Close match search" : "Search matches"}
              aria-expanded={searchToogle}
              aria-controls="desktop-header-search"
              onClick={() => { setAccountOpen(false); setSearchToogle(previous => !previous); }}
            ><FaSearchPlus aria-hidden="true" /></button>
            {isEmpty(user) ? (
              <form className="desktop-login-form" onSubmit={event => { event.preventDefault(); setShowAgeModal(true); }}>
                <input type="text" name="username" autoComplete="username" aria-label="Username" placeholder="Username" required value={credentials.username} onChange={event => setCredentials(previous => ({ ...previous, username: event.target.value }))} />
                <input type="password" name="password" autoComplete="current-password" aria-label="Password" placeholder="Password" required value={credentials.password} onChange={event => setCredentials(previous => ({ ...previous, password: event.target.value }))} />
                <button type="submit" disabled={submitting}>{submitting ? "Logging in…" : "Login"} <FaSignInAlt /></button>
                {loginError && <span className="desktop-login-error" role="alert">{loginError}</span>}
              </form>
            ) : (
              <div className="desktop-account-actions">
                <div className="desktop-wallet-balance">
                  <span>Main PTI {userCoins?.totalCoins?.toFixed(2) || "0.00"}</span>
                  <span>Exposure (<span className="desktop-wallet-exposure">{userCoins?.exp?.toFixed(2) || userCoins?.exposure?.toFixed(2) || "0.00"}</span>)</span>
                </div>
                <button type="button" className="desktop-balance-refresh" onClick={getCoins} aria-label="Refresh balance" aria-busy={refresh}>
                  <FaUndo aria-hidden="true" />
                </button>
                <div className="desktop-account-menu" ref={accountRef} onBlur={event => {
                  if (!event.currentTarget.contains(event.relatedTarget)) setAccountOpen(false);
                }}>
                  <button
                    type="button"
                    className="desktop-account-toggle"
                    ref={accountButtonRef}
                    aria-expanded={accountOpen}
                    aria-controls="desktop-account-dropdown"
                    onClick={() => setAccountOpen(previous => !previous)}
                  >
                    <FaUser aria-hidden="true" />
                    My Account
                    <FaCaretDown aria-hidden="true" />
                  </button>
                  {accountOpen && (
                    <div id="desktop-account-dropdown" className="desktop-account-dropdown" role="region" aria-label="My Account">
                      <div className="desktop-account-heading">exchange</div>
                      {[
                        ["My Profile", "my-profile"],
                        ["Rolling Commission", "rolling-commission"],
                        ["Account Statement", "account-statement"],
                        ["Bets History", "bets-history"],
                        ["Profit & Loss", "profit-and-loss"],
                        ["Password History", "password-history"],
                        ["Activity Log", "activity-logs"],
                      ].map(([label, path]) => (
                        <Link
                          key={path}
                          to={`/${path}`}
                          onClick={() => setAccountOpen(false)}
                        >{label}</Link>
                      ))}
                      <div className="desktop-account-footer">
                        <button type="button" className="desktop-account-logout" onClick={() => { setAccountOpen(false); logoutUser(); }}>
                          LOGOUT <FaSignOutAlt aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : isEmpty(user) ? (<div className="login-header-new">
        <div className="login-reg-wrapper">
          <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* <button
              className="bg-transparent border-0 text-white"
              onClick={() => handleShowSidebar()}
            >
              <MdOutlineSubject className="fs-4" style={{ color: '#fff' }} />
            </button> */}
            <figure onClick={() => navigate("/")}>
              {/* {isEmpty(user) ? (
            <img
              style={{
                height: "50px",
              }}
              src={logo}
              alt=""
            />):  */}
              <img
                style={{
                  height: "auto",
                  maxWidth: "160px"
                }}
                src={logo}
                alt=""
              />
              {/* } */}
              {/*<div class="hd-spon hd-spon--ani">
              <ul class="hd-spon__icon">
                <li>
                  <img src={bournemouth} alt="icon-sponsor" class="spon-icon" />
                  <img src={bologna} alt="icon-sponsor" class="spon-icon" />
                </li>
                <li>
                  <img src={bologna} alt="icon-sponsor" class="spon-icon" />
                  <img src={bournemouth} alt="icon-sponsor" class="spon-icon" />
                </li>
              </ul>
            </div> */}
            </figure>
          </div>
          {isEmpty(user) ? (
            <div className="newcssadd">
              <div className="header-btn">
                {/* <a
                  href="https://agentsbook.bet/"
                  target="_blank"
                  className="btn-signup ui-link"
                >
                  Agent List
                </a> */}
                <button
                  className="login-index ui-link"
                  onClick={() => setShowAgeModal(true)}
                  style={{
                    fontFamily: 'Tahoma, Helvetica, sans-serif',
                    fontSize: '12px',
                    color: '#FFFFFF',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    margin: '0px 8px 0px 4.5px',
                    padding: '6px 12px',
                    alignSelf: 'center',
                  }}
                >
                  Login <FaSignInAlt style={{ fontSize: '13px', color: '#FFFFFF', fill: '#FFFFFF', flexShrink: 0 }} />
                </button>
              </div>
            </div>


          ) : (
            


            <div className="align-items-lg-start for-ref after-login">
              {refreshAmountLoader ? (
                <div class="loader-outer">
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: "0s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".1s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".2s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".3s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".4s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".5s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".6s" }}
                  ></span>
                  <span
                    class="loader-inner-icon"
                    style={{ animationDelay: ".7s" }}
                  ></span>
                </div>
              ) : (
                <>
                  {/* <div className="header-blance-block">
                    <div className="header-blance">
                      <div className=""
                      style={{display:'flex', alignItems:'center', justifyContent:'space-between', minHeight:'110px'}}>
                        <div className="" style={{display:'block'}}>
                        <span style={{display:'block'}}>{user?.user?.username}</span>
                        <span>BDT: {userCoins?.totalCoins?.toFixed()} Exp 0.00</span>
                        </div>
                        <div className="header-right-box">+5</div>
                      </div>
                      <div className="refresh_blance-box"><MdOutlineRefresh /></div>
                    </div>
                    <div className="setting_block">
                      <IoMdSettings />
                    </div>
                  </div> */}
                  {/* <div class="desktop-log-reg">
                    <span className="v-btn__content3" onClick={() => logoutUser()} title="Logout"><img src={logoutImg} /></span>

                  </div> */}
                </>
              )}
            </div>
          )}
          {/*<div className="header-right-btn-group">
          
            <a href={bajiApk}  download="Baji247 App" target='_blank'><img src={appdownloadicon} /><span>App</span></a>
            <a href="#"><img src={headerserviceicon}/><span >Help</span></a>
            </div>*/}
        </div>

      </div>
      ) : (
        <div className="style09 headerMain1-block">
          <header id="headerMain1" style={{
            position: ' fixed',
            zIndex: ' 99', width: '100%', left: '0'
          }}>
            <MessageBox />
            <ul>
              <li className="li-tv_bet">
                <a
                  id="openBetsBtn"
                  className="a-open_bets ui-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenBetsToogle(true);
                  }}
                  href="#open-bets"
                  style={{
                    cursor: "pointer",
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontFamily: 'Tahoma, Helvetica, sans-serif',
                    padding: '10.218px 12.0337px',
                    margin: '0px 0px 0px 2px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '80px',
                    height: '36.68px',
                    flex: 'none',
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    border: '1px solid #000',
                    borderRadius: '6px',
                  }}
                >
                  <img
                    src="https://baji24.com/assets/images/transparent.gif  "
                    alt=""
                    style={{
                      background: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="white" fill-rule="nonzero" d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z"/></svg>') no-repeat`,
                      backgroundSize: 'contain',
                    }}
                  />
                  Bets
                </a>
              </li>

              <li className="main-wallet" style={{ border: 'none' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', rowGap: '5px', flex: 1, border: 'none', paddingRight: '10px' }}>
                  <span style={{ color: '#fff', fontSize: '12px', fontWeight:'700',fontFamily: 'Tahoma, Helvetica, sans-serif' }}>
                    Main PTI {userCoins?.totalCoins?.toFixed(2) || '0.00'}
                  </span>
                  <span style={{ color: '#fff', fontSize: '12px',fontWeight:'700', fontFamily: 'Tahoma, Helvetica, sans-serif' }}>
                    Exposure (<span style={{ color: 'red' }}>{userCoins?.exp?.toFixed(2) || userCoins?.exposure?.toFixed(2) || '0.00'}</span>)
                  </span>
                </div>
                <a
                  className="a-refresh ui-link"
                  id="menuRefresh"
                  title="Refresh Main Wallet"
                  onClick={() => getCoins()}
                  style={{
                    width: '36px',
                    height: '36px',
                    flex: 'none',
                    boxSizing: 'border-box',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    background: 'var(--site-header-gradient)',
                    border: '1px solid #000',
                    borderRadius: '4px',
                    padding: '7px',
                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.3)',
                    cursor: 'pointer',
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                    style={{ display: 'block', flexShrink: 0 }}
                  >
                    <path
                      fill="#fff"
                      d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="a-setting ui-link"
                  title="Setting"
                  onClick={(e) => {
                    e.preventDefault();
                    setSettingToogle(!settingToogle);
                  }}
                  href="#setting"
                  style={{ cursor: "pointer", border: '1px solid #000', borderRadius: '8px', padding: '8px' }}
                >
                  <img
                    src="https://baji24.com/assets/images/transparent.gif  "
                    alt=""
                    style={{
                      width: '20px',
                      height: '20px',
                    }}
                  />
                </a>
              </li>
            </ul>
            <div id="multiWalletDiv" className={`overlay ${showMultiWallet ? '' : 'hide-wallet'}`} style={{ display: showMultiWallet ? "block" : "none" }}> {/* Dynamic style based on state */}
              <div className="wallet-detail">
                <div className="wallet-detail-group">
                  <dl className="wallet-detail-content">
                    <dt>Main Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="currency">
                        PBU
                      </span>
                      <span id="mainBalance">{amount}</span>
                    </dd>
                    <dd className="wallet-exposure">
                      Exposure{" "}
                      <span id="mainExposure" className="red">
                        ( 0.00)
                      </span>
                    </dd>
                  </dl>
                </div>
                <div id="walletContent" className="wallet-detail-group">
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_6">International Casino Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_6">
                        Casino Exposure
                      </span>
                      <span id="vendorBalance_6" className="red">
                        0
                      </span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_6"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_1">Casino Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_1">
                        PBU
                      </span>
                      <span id="vendorBalance_1"> </span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_1"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_3">BPoker Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_3">
                        PBU
                      </span>
                      <span id="vendorBalance_3">0 Points</span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_3"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_5">SABA Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_5">
                        PBU
                      </span>
                      <span id="vendorBalance_5">0</span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_5"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle_4">Sky Trader Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency_4">
                        PBU
                      </span>
                      <span id="vendorBalance_4">0</span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall_4"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="recallAllDl" className="wallet-detail-content">
                    <dd className="align-R">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recallAll"
                      >
                        Recall All
                      </button>
                    </dd>
                  </dl>
                </div>
                <div
                  id="walletTemp"
                  className="wallet-detail-group"
                  style={{ display: "none" }}
                >
                  <dl id="tempDl" className="wallet-detail-content">
                    <dt id="vendorTitle">Housie Balance</dt>
                    <dd className="wallet-balance-num">
                      <span className="badge-currency" id="vendorCurrency">
                        PBU
                      </span>
                      <span id="vendorBalance">$ 0.00</span>
                    </dd>
                    <dd className="wallet-recall">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recall"
                      >
                        Recall
                      </button>
                    </dd>
                  </dl>
                  <dl id="recallAllDl" className="wallet-detail-content">
                    <dd className="align-R">
                      <button
                        className="btn-recall ui-btn ui-shadow ui-corner-all"
                        id="recallAll"
                      >
                        Recall All
                      </button>
                    </dd>
                  </dl>
                </div>
                <div className="btn-box" onClick={toggleMultiWallet}>
                  <button
                    className="btn ui-btn ui-shadow ui-corner-all"
                    id="balanceClose"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </header>

        </div>
      )}

      {showSidebar && (
        <MenuSidebarNew
          cancelMenu={handleShowSidebar}
          showSidebar={showSidebar}
        />
      )}

      {showSidebar && (
        <div className="overlay" onClick={() => handleShowSidebar()}></div>
      )}

      <AgeConfirmationModal show={showAgeModal} onClose={() => setShowAgeModal(false)} onConfirm={desktopHome && isDesktop ? submitDesktopLogin : undefined} />

    </>
  );
};

export default HeaderNew;